import { jsx as r } from "react/jsx-runtime";
const m = ({
  children: e,
  ...o
}) => /* @__PURE__ */ r("legend", { style: { marginBottom: "var(--el-core-space-1)" }, ...o, children: e });
export {
  m as Legend
};
